import React from "react";

interface CustomChecklistItemProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  className?: string;
}

const CustomChecklistItem: React.FC<CustomChecklistItemProps> = ({
  label,
  isSelected,
  onClick,
  className = "",
}) => {
  return (
    <button
      className={`flex py-2 px-4 rounded-full ${
        isSelected ? "bg-BCP-blue-selected-bg" : "bg-light-gray"
      } `}
      onClick={onClick}
    >
      <span
        className={`font-flexo-demi ${
          isSelected ? "text-BCP-blue-selected-text" : "text-BCP-dark-gray"
        } ${className}`}
      >
        {label}
      </span>
    </button>
  );
};

export default CustomChecklistItem;
